// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
export const getProfile = state => state.profileReducer.profile;
export const getChangePassword = state => state.profileReducer.changePassword;
export const getAddress = state => state.profileReducer.profile.address;
export const getPayment = state => state.profileReducer.profile.bank;
export const getPaypal = state => state.profileReducer.profile.paypal;
export const getErrors = state => state.profileReducer.errors;
export const getSuccess = state => state.profileReducer.success;
export const getValidatePaypalResult = state => state.profileReducer.validatePaypalResult;
export const getConfirmPaypalEmail = state => state.profileReducer.ConfirmPaypalEmail;
